import { useState, useEffect } from "react";
import { PaymentMethod } from "../constants/payment";

/**
 * Custom hook for QR code countdown timer
 */
export function useQRCountdown(method, initialTimeLeft) {
  const [timeLeft, setTimeLeft] = useState(initialTimeLeft);

  useEffect(() => {
    setTimeLeft(initialTimeLeft);
  }, [initialTimeLeft]);

  useEffect(() => {
    if (method !== PaymentMethod.QR_CODE && method !== PaymentMethod.MMQR)
      return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, [method]);

  return timeLeft;
}
